import Tabs from '../tabs';
import initHomepageLoadMoreProperties from '../property/homepage-load-more';
import Discardable from '../property/discard';
import initPropertySliders from '../property/sliders';
import initCharacterLimit from '../characterlimit';
import initResumeUploadForm from '../resume/upload';

class Homepage {
    constructor() {
        const tabs = document.querySelector( '.twc__tabs' );

        if ( tabs ) {
            new Tabs( tabs );

            tabs.addEventListener( 'twc:tabs-show', function( event: CustomEvent ) {
                const container = event.detail.activeBtn.dataset.target;
                const actionContainer = event.detail.activeBtn.dataset.featuredActionContainer;
                const offer = event.detail.activeBtn.dataset.featuredOffer;

                const offerField = document.querySelector<HTMLInputElement>( '.featured-properties [name=offer]' );

                if ( !offerField ) {
                    throw new Error( 'failed to find a [name=offer] field' );
                }

                offerField.value = offer;

                const containerProperties = event.detail.activePane.querySelectorAll( '[data-property-id]' );

                if ( containerProperties.length === 0 ) {
                    initHomepageLoadMoreProperties( document.querySelector( container ), document.querySelector( actionContainer ) );
                }
            } );
        }

        const forms = document.querySelectorAll<HTMLFormElement>( 'form[data-auto-submit=true]' );

        for ( let i = 0; i < forms.length; i++ ) {
            forms[ i ].addEventListener( 'submit', function( event: Event ) {
                if ( !event.target ) {
                    return;
                }

                event.preventDefault();
                ( event.target as HTMLFormElement ).submit();
            } );
        }

        new Discardable();

        initResumeUploadForm();

        initPropertySliders();

        initCharacterLimit();
    }
}

if ( !window.homepage ) {
    window.homepage = new Homepage();
}
